import { Printer, X } from "lucide-react";

const num = (n) => (n == null ? "" : new Intl.NumberFormat("id-ID").format(n));
const fmtD = (s) => { if (!s) return "-"; const p = String(s).slice(0, 10).split("-"); return p.length === 3 ? `${p[2]}-${p[1]}-${p[0]}` : s; };
const MODULE_TITLE = { PENGAMBILAN: "PENGAMBILAN", SETORAN: "SETORAN", RIJEK_SUSULAN: "RIJEK SUSULAN", RIJEK_KIRIM: "RIJEK / KIRIM PERBAIKAN", RIJEK_TERIMA: "RIJEK / TERIMA PERBAIKAN" };

function buildRows(doc) {
  const trx = doc.transactions || [];
  if (doc.source_module === "SETORAN") {
    return trx.map((t) => ({ cols: [t.product_name || t.product_id, `${num(t.quantity)}`, `${num(t.repair_quantity || 0)}`, `${num(t.good_quantity)}`] }));
  }
  if (doc.source_module === "RIJEK_SUSULAN") {
    return trx.filter((t) => t.transaction_type === "RIJEK").map((t) => ({ cols: [t.product_name || t.product_id, `${num(t.quantity)}`, t.notes || "-"] }));
  }
  const items = trx.filter((t) => t.transaction_type === "AMBIL").map((t) => ({ group: "ITEM", cols: [t.ref_no || "-", t.product_name || t.product_id, `${num(t.quantity)} PCS`] }));
  const tools = trx.filter((t) => t.transaction_type === "BON").map((t) => ({ group: "TOOL", cols: [t.bon_item_name || "-", num(t.quantity), t.unit || "PCS"] }));
  return [...items, ...tools];
}

function chunk(arr, size) { const out = []; for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size)); return out; }

export default function OpReceipt({ doc, onClose }) {
  if (!doc) return null;
  const isSetor = doc.source_module === "SETORAN";
  const isSusulan = doc.source_module === "RIJEK_SUSULAN";
  const isRijekTicket = doc.source_module === "RIJEK_KIRIM" || doc.source_module === "RIJEK_TERIMA";
  const rows = isRijekTicket ? [] : buildRows(doc);
  const pages = isRijekTicket ? [[]] : (rows.length ? chunk(rows, 10) : [[]]);
  const totalPages = pages.length;

  const totSetor = isSetor ? (doc.transactions || []).reduce((a, t) => a + (t.quantity || 0), 0) : 0;
  const totRijek = isSetor ? (doc.transactions || []).reduce((a, t) => a + (t.repair_quantity || 0), 0) : 0;
  const totBagus = isSetor ? (doc.transactions || []).reduce((a, t) => a + (t.good_quantity || 0), 0) : 0;

  const Kop = ({ pi }) => (
    <div className="border-b-2 border-black pb-2 mb-2">
      {pi === 0 && <img src="/logo-meranggi-bw.png" alt="Meranggi" className="mx-auto w-24 h-24 mb-1 object-contain" data-testid="op-receipt-logo" />}
      <div className="text-center font-extrabold tracking-wide text-[15px]">{MODULE_TITLE[doc.source_module] || doc.source_module}</div>
      <div className="text-center text-[10px]">CV. MERANGGI JAYA</div>
      {doc.revision_marker && (
        <div className={`mt-1 mx-auto w-fit border-2 px-3 py-0.5 text-center font-extrabold tracking-widest text-[13px] ${doc.revision_marker === "DIBATALKAN" ? "border-black line-through" : "border-black"}`} data-testid="op-receipt-marker">
          {doc.revision_marker === "DIKOREKSI" ? "SUDAH DIKOREKSI" : doc.revision_marker}
          {doc.revision_of && <span className="block text-[9px] font-semibold tracking-normal no-underline">Revisi dari {doc.revision_of}</span>}
          {doc.superseded_by && <span className="block text-[9px] font-semibold tracking-normal no-underline">Lihat revisi {doc.superseded_by}</span>}
        </div>
      )}
      <div className="flex justify-between text-[11px] mt-1">
        <span>No. Bukti: <b>{doc.op_no}</b></span><span className="whitespace-nowrap">Hal. {pi + 1}/{totalPages}</span>
      </div>
      <div className="flex justify-between text-[11px]">
        <span>Pengepul: <b>{doc.worker_id || "-"}</b> · {doc.worker_name || "-"}</span><span>{fmtD(doc.date)}</span>
      </div>
      <div className="text-[10px] text-right">Petugas: {doc.entry_by || "-"}</div>
    </div>
  );

  const handlePrint = () => {
    const area = document.getElementById("op-print-area");
    if (!area) { window.print(); return; }
    const styles = Array.from(document.querySelectorAll('link[rel="stylesheet"], style')).map((n) => n.outerHTML).join("");
    const w = window.open("", "PRINT", "width=420,height=640");
    if (!w) { window.print(); return; }
    w.document.write(`<!doctype html><html><head><title>${doc.op_no}</title><base href="${window.location.origin}/">${styles}</head><body style="background:#fff;margin:0;padding:8px;"><div id="op-print-area" class="font-mono text-[12px] text-black">${area.innerHTML}</div></body></html>`);
    w.document.close(); w.focus();
    const fire = () => { try { w.focus(); w.print(); } catch (e) {} };
    w.onafterprint = () => w.close();
    const waitImgs = () => {
      const imgs = Array.from(w.document.images || []);
      if (!imgs.length || imgs.every((im) => im.complete)) { setTimeout(fire, 150); return; }
      Promise.all(imgs.map((im) => im.complete ? Promise.resolve() : new Promise((res) => { im.onload = im.onerror = res; }))).then(() => setTimeout(fire, 150));
    };
    if (w.document.readyState === "complete") waitImgs();
    else w.onload = waitImgs;
  };

  return (
    <div className="fixed inset-0 z-[60] bg-black/40 flex items-start sm:items-center justify-center overflow-y-auto p-3" data-testid="op-receipt-modal">
      <div className="bg-white rounded-xl w-full max-w-sm my-4 flex flex-col max-h-[90vh]">
        <div className="flex items-center justify-between px-4 py-3 border-b no-print shrink-0">
          <div className="font-semibold text-slate-800">Struk · {doc.op_no}</div>
          <div className="flex gap-2">
            <button onClick={handlePrint} className="inline-flex items-center gap-1.5 bg-[#0071E3] text-white px-3 py-1.5 rounded-full text-sm" data-testid="op-receipt-print"><Printer className="w-4 h-4" />Cetak</button>
            <button onClick={onClose} className="p-1.5 rounded-full hover:bg-slate-100" data-testid="op-receipt-close"><X className="w-5 h-5" /></button>
          </div>
        </div>
        <div id="op-print-area" className="p-4 font-mono text-[12px] text-black overflow-y-auto flex-1">
          {pages.map((pg, pi) => (
            <div key={pi} className="op-page">
              <Kop pi={pi} />
              {isRijekTicket ? (
                <div className="space-y-1 text-[11px]">
                  <div>Tiket: <b>{doc.repair_id}</b></div>
                  <div>Barang: {doc.product_name || doc.product_id || "-"}</div>
                  <div>Jumlah: {num(doc.qty)} PCS {doc.returned_qty != null && `· Kembali bagus: ${num(doc.returned_qty)}`}</div>
                  <div>Status: {doc.status}</div>
                </div>
              ) : isSetor ? (
                <table className="w-full text-[11px]">
                  <thead><tr className="border-b border-black"><th className="text-left py-0.5">BARANG</th><th className="text-right">SETOR</th><th className="text-right">RIJEK</th><th className="text-right">BAGUS</th></tr></thead>
                  <tbody>{pg.map((r, i) => <tr key={i} className="border-b border-dashed border-slate-300"><td className="py-0.5">{r.cols[0]}</td><td className="text-right">{r.cols[1]}</td><td className="text-right">{r.cols[2]}</td><td className="text-right">{r.cols[3]}</td></tr>)}</tbody>
                </table>
              ) : isSusulan ? (
                <table className="w-full text-[11px]">
                  <thead><tr className="border-b border-black"><th className="text-left py-0.5">BARANG</th><th className="text-right">RIJEK</th><th className="text-left pl-2">KETERANGAN</th></tr></thead>
                  <tbody>{pg.map((r, i) => <tr key={i} className="border-b border-dashed border-slate-300"><td className="py-0.5">{r.cols[0]}</td><td className="text-right">{r.cols[1]}</td><td className="pl-2">{r.cols[2]}</td></tr>)}</tbody>
                </table>
              ) : (
                <>
                  {pg.some((r) => r.group === "ITEM") && <>
                    <div className="text-[10px] font-bold">RINCIAN POTONGAN</div>
                    <table className="w-full text-[11px]"><thead><tr className="border-b border-black"><th className="text-left">NO. POTONGAN</th><th className="text-left">BARANG</th><th className="text-right">JUMLAH</th></tr></thead>
                      <tbody>{pg.filter((r) => r.group === "ITEM").map((r, i) => <tr key={i} className="border-b border-dashed border-slate-300"><td>{r.cols[0]}</td><td>{r.cols[1]}</td><td className="text-right">{r.cols[2]}</td></tr>)}</tbody></table>
                  </>}
                  {pg.some((r) => r.group === "TOOL") && <>
                    <div className="text-[10px] font-bold mt-2">BON ALAT JAHIT{pi > 0 ? " (LANJUTAN)" : ""}</div>
                    <table className="w-full text-[11px]"><thead><tr className="border-b border-black"><th className="text-left">NAMA ALAT</th><th className="text-right">JUMLAH</th><th className="text-right">SATUAN</th></tr></thead>
                      <tbody>{pg.filter((r) => r.group === "TOOL").map((r, i) => <tr key={i} className="border-b border-dashed border-slate-300"><td>{r.cols[0]}</td><td className="text-right">{r.cols[1]}</td><td className="text-right">{r.cols[2]}</td></tr>)}</tbody></table>
                  </>}
                </>
              )}
              {pi === totalPages - 1 && isSetor && (
                <div className="mt-2 pt-1 border-t border-black text-[11px] space-y-0.5">
                  <div className="flex justify-between"><span>TOTAL SETOR</span><b>{num(totSetor)}</b></div>
                  <div className="flex justify-between"><span>TOTAL RIJEK</span><b>{num(totRijek)}</b></div>
                  <div className="flex justify-between"><span>DITERIMA BAGUS</span><b>{num(totBagus)}</b></div>
                </div>
              )}
              {pi === totalPages - 1 && isSusulan && (
                <div className="mt-2 pt-1 border-t border-black text-[11px]">
                  <div className="flex justify-between"><span>TOTAL RIJEK</span><b>{num((doc.transactions || []).reduce((a, t) => a + (t.quantity || 0), 0))}</b></div>
                </div>
              )}
              {pi === totalPages - 1 && (
                <div className="flex justify-between mt-6 text-[10px]"><span>Petugas<br /><br />( {doc.entry_by || "____"} )</span><span className="text-right">Pengepul<br /><br />( {doc.worker_name || "____"} )</span></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
